import React from "react";
import { useDispatch } from "react-redux";
import { Grid } from "@material-ui/core";
import CircularLoader from "components/Loaders/CircularLoader";
import InvoiceAttachmentsTable from "./Table/index";
import AttachmentForm from "./Form/index";
import useDocumentId from "./useDocumentId";
import {
	fetchInvoiceAttachmentsDocTypes,
	fetchInvoiceAttachments,
} from "../../../../../redux/actions/invoices";

export default () => {
	const dispatch = useDispatch();
	const [loaded, setLoaded] = React.useState(false);
	const documentId = useDocumentId();

	React.useEffect(() => {
		dispatch(
			fetchInvoiceAttachmentsDocTypes(() => {
				setLoaded(true);
			})
		);
		dispatch(fetchInvoiceAttachments(documentId));
	}, []);

	return (
		<>
			{loaded ? (
				<Grid container xs={12}>
					<AttachmentForm />
					<InvoiceAttachmentsTable />
				</Grid>
			) : (
				<CircularLoader />
			)}
		</>
	);
};
